<template>
  <td data-int="cart-cell-subChapter">
    {{ item.subChapterName }}
  </td>
</template>

<script>
export default {
  name: 'CartCellSubChapter',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>

</style>
